import {Fade} from "reactstrap";
import React from "react";


const FromValidationError = props => (
    <Fade in={Boolean(props.field)} tag="p" className="error" data-testid="form.validationError">
        {props.field ? Object.values(props.field).shift() : ''}
    </Fade>
);

export default FromValidationError;